import React, { useEffect, useState } from "react";
import "./Statistic.css";
import { GrClose } from "react-icons/gr";
function Statistic({ setStatistic }) {
  const [info, setInfo] = useState([]);

  async function fetchStatic() {
    try {
      const link = `${process.env.REACT_APP_BASE_URL}/api/object_params/getAllStat`;
      const res = await fetch(link);
      const results = await res.json();

      // считаем общий итог
      const totalCount = results.reduce(
        (sum, item) => sum + Number(item.total_count),
        0
      );

      const totalRow = {
        typecode: "",
        typename: "Всего:",
        total_count: totalCount,
      };

      setInfo([...results, totalRow]);
    } catch (error) {
      console.error("Ошибка загрузки статистики:", error);
    }
  }

  useEffect(() => {
    fetchStatic();
  }, []);

  const handleClose = () => {
    setStatistic(false);
  };

  return (
    <div className="statistic__modal">
      <div className="statistic__block">
        <table>
          <thead>
            <tr>

              <th>Тип</th>
              <th>Введено</th>
            </tr>
          </thead>

          <tbody>
            {info.map((data, index) => (
              <tr
                key={index}
                style={
                  data.typename === "Всего:"
                    ? { fontWeight: "bold", background: "#f5f5f5" }
                    : {}
                }
              >
   
                <td>{data.typename}</td>
                <td>{data.total_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="statistic__close" onClick={handleClose}>
        <GrClose />
      </div>
    </div>
  );
}

export default Statistic;